import * as yup from 'yup'

export default [
  {
    id: 'first-name',
    name: 'firstName',
    label: 'smb_acquisition_broker_company_info.fields.first_name.placeholder',
    componentType: 'input',
    columnSize: {
      small: 12,
      medium: 6,
    },
    validations: {
      primitiveType: 'string',
      required: true,
    },
  },

  {
    id: 'last-name',
    name: 'lastName',
    label: 'smb_acquisition_broker_company_info.fields.last_name.placeholder',
    componentType: 'input',
    columnSize: {
      small: 12,
      medium: 6,
    },
    validations: {
      primitiveType: 'string',
      required: true,
    },
  },

  {
    id: 'email',
    name: 'email',
    label: 'smb_acquisition_broker_company_info.fields.email.placeholder',
    componentType: 'input',
    columnSize: {
      small: 12,
      medium: 6,
    },
    validations: {
      primitiveType: 'string',
      email: true,
      required: false,
      notEqualBrokerEmail: true,
    },
    customValidations: [
      {
        key: 'notEqualBrokerEmail',
        type: yup.string,
        test(email) {
          const { brokerEmail } = this.parent
          if (email !== brokerEmail) {
            return true
          }
          return false
        },
      },
    ],
  },
  {
    id: 'company',
    name: 'company',
    label:
      'smb_acquisition_broker_company_info.fields.company_name.placeholder',
    componentType: 'input',
    columnSize: {
      small: 12,
      medium: 6,
    },
    validations: {
      primitiveType: 'string',
      required: true,
    },
  },

  {
    id: 'state',
    name: 'state',
    label:
      'smb_acquisition_broker_company_info.fields.headquarter_location.placeholder',
    componentType: 'select',
    columnSize: {
      small: 12,
      medium: 6,
    },
    items: {},
    validations: {
      primitiveType: 'string',
      required: true,
    },
  },
  {
    id: 'employees-number',
    name: 'employeesNumber',
    label:
      'smb_acquisition_broker_company_info.fields.employee_number.placeholder',
    componentType: 'input',
    columnSize: {
      small: 12,
      medium: 6,
    },
    validations: {
      primitiveType: 'number',
      required: true,
      typeError: true,
      positive: true,
      integer: true,
    },
  },
]
